import { render, staticRenderFns } from "./AbilitiesCard.vue?vue&type=template&id=7a934872&scoped=true&"
import script from "./AbilitiesCard.vue?vue&type=script&lang=js&"
export * from "./AbilitiesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a934872",
  null
  
)

export default component.exports